/**
 * CoffeeButton Component
 * STANDALONE - Extracted from App.jsx line 391-399
 */

import './CoffeeButton.css'

function CoffeeButton() {
  return (
    <a
      href="https://buymeacoffee.com/abet"
      target="_blank"
      rel="noopener noreferrer"
      className="coffee-btn"
      title="Buy Me a Coffee"
    >
      <i className="fas fa-mug-hot"></i>
    </a>
  )
}

export default CoffeeButton
